
      window.SiteSurveyConfig = {
        supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
        supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY
      };
      window.__APP_ENV__ = import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'production';
      window.__BUILD_COMMIT_SHA__ = import.meta.env.VITE_BUILD_COMMIT_SHA || '';
      window.__BUILD_RELEASE__ = import.meta.env.VITE_RELEASE || '';
    